module.exports = __webpack_public_path__ + "img/library-loose.00dc5e81.png";